import type { KeyValue } from "../models/KeyValue";
import type { Role } from "../models/Role";
import { CreateCrudService } from "./CrudServiceFactory";

export function RoleService() {
  return CreateCrudService<Role, KeyValue>({
    Route: "role",
    PaginationInPath: true,
    DeleteAction: "DeleteRole",
    EntityName: "Role",
    PartialFields: ["Name", "Code"],
    LoadingMessage: "Loading roles...",
    SavingMessage: "Saving role...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.Name ?? ""),
    }),
  });
}
